import history from './History';
export default function Workaround(){
    history.push('/job/all')
    return null;
}